import React, { useState } from 'react';
import ManualConsentActions from './ManualConsentActions';
import AButton from '../../../../../common/form-fields-mui/AButton';
import styles from "./styles.module.scss"
import DigitalConsentInProgress from './DigitalConsentInProgress';
import ConsentReceived from './ConsentReceived';
import DocUploadModal from '../../paymentMode/DocUploadModal';
import { checkPermission, fetchAllPostPromisedData } from '../../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../common/constant';
import { successToast } from '../../../../../common/utils/methods/toasterFunctions/function';
import useConfirm from '../../../../../common/commonComponents/ConfirmationDialog/confirmationPrompt';


const ParentConsent = ({
    createManualParentConsentForm,
    applicationDetails,
    setAsyncLoader,
    consentInfo,
    getConsentDetails,
    viewOnly,
    userPermissions
}) => {

    const isCreateOrUpdatePermission = checkPermission(userPermissions, ["C", "U"]);
    const enableUserActions = !viewOnly && isCreateOrUpdatePermission;

    const [consentUploadDialogOpen, setConsentUploadDialogOpen] = useState(false);
    const [SendDigitalConsentConfirmationDialog, confirmProceed] = useConfirm();

    const { applicationQuotationDetailsId: latestQuotationId, psid, email, phoneNo, applicationId } = applicationDetails;

    const uploadManualConsent = async (s3Path) => {
        try {
            const reqObj = {
                s3Path,
                psId: psid,
                quotationId: latestQuotationId,
                applicationId 
            }

            const resp = await fetchAllPostPromisedData(endpoint.parentConsent.uploadConsent, reqObj);
            if (resp?.code === 200) {
                successToast("Manual Consent uploaded successfully!!!");
                setConsentUploadDialogOpen(false);
                getConsentDetails();
            }

        } catch (err) {
            console.error(err);
        }
    }

    const sendDigitalConsentNotification = async () => {
        try {

            const canContinue = await confirmProceed();
            if (!canContinue) return;

            setAsyncLoader(true);

            const reqObj = {
                psId: psid,
                quotationId: latestQuotationId
            }

            const resp = await fetchAllPostPromisedData(endpoint.parentConsent.sendDigitalConsentNotification, reqObj);
            if (resp?.code === 200) {
                successToast("Request completed successfully!!");
                getConsentDetails();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setAsyncLoader(false);
        }
    };


    const {
        manualConsentReceivedDate,
        digitalConsentReceivedDate,
        digitalConsentSentDate,
        manualConsentS3Path,
        digitalConsentS3Path,
        updatedBy,
        mobileNo,
        emailId
    } = consentInfo;

    const manualConsentReceived = !!manualConsentS3Path;
    const digitalConsentSent = !!digitalConsentSentDate;
    const digitalConsentReceived = !!digitalConsentS3Path;
    const noConsentReceived = !digitalConsentReceived && !manualConsentReceived;

    return (
        <div className={`${styles['parent-consent']}`}>

            <div className='d-flex justify-content-between'>

                <div className={`${styles['parent-consent-heading']}`}>Parent Consent</div>

                {noConsentReceived &&
                    <ManualConsentActions
                        setConsentUploadDialogOpen={setConsentUploadDialogOpen}
                        createManualParentConsentForm={createManualParentConsentForm}
                        setAsyncLoader={setAsyncLoader}
                        enableUserActions={enableUserActions}
                    />

                }

            </div>

            {noConsentReceived &&
                <>
                    <div className={`mt-1 ${styles['consent-msg']}`}>
                        Please obtain parental consent online or, if preferred, download the form, get it signed manually, and upload it here.
                    </div>

                    {enableUserActions && !digitalConsentSent && <AButton
                        variant='primary_filled'
                        onClick={sendDigitalConsentNotification}
                        className='mt-3'
                    >
                        Take digital Consent
                    </AButton>
                    }
                </>
            }

            {(digitalConsentReceived || manualConsentReceived) &&
                <ConsentReceived
                    consentRecievedDate={digitalConsentReceivedDate ?? manualConsentReceivedDate}
                    consentS3Path={digitalConsentS3Path ?? manualConsentS3Path}
                    setAsyncLoader={setAsyncLoader}
                    updatedBy={updatedBy}
                />}


            {(digitalConsentSent && !digitalConsentReceived) &&
                <DigitalConsentInProgress
                    email={emailId}
                    phoneNo={mobileNo}
                    digitalConsentSentDate={digitalConsentSentDate}
                    sendDigitalConsentNotification={sendDigitalConsentNotification}
                    enableUserActions={enableUserActions}
                />}


            {enableUserActions && manualConsentReceived && !digitalConsentSent &&
                <div className={`${styles['take-digital-consent-msg']}`}>
                    You can take digital consent also.&nbsp;
                    <span onClick={sendDigitalConsentNotification}>
                        Take Digital Consent
                    </span>
                </div>
            }

            <DocUploadModal
                open={consentUploadDialogOpen}
                setOpen={setConsentUploadDialogOpen}
                saveHandler={uploadManualConsent}
                acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                maxUploadFileSize={10}
                serviceName={'PARENT_CONSENT_WEBFORM'}
                uniqueKeyParameter={"paymentCollectionImage"}
                modalTitle={"Upload Parent Consent"}

            />

            <SendDigitalConsentConfirmationDialog
             message={
                `This will send notification to ${mobileNo} and ${emailId} for digital consent.`
              }
              title={"Are you sure ?"}
              nextButtonText={"Yes, Continue"}
              backButtonText={"No"}
              leftAlign={true}
            />
        </div>
    );
}

export default ParentConsent;